import Dock from './dock.svg';
import Undock from './undock.svg';

export default {
  Dock,
  Undock,
};
